module.exports = __webpack_public_path__ + "static/cabina-conductor---grada-de-ingreso-bc66f85352373955349c9b946b002aea.jpg";